import { putPastedExternalContent } from "./putPastedContent.mjs";
async function pasteFiles(editor, blobs, point, sources, clipboardPasteSource = "native-event") {
  const files = blobs.map(
    (blob) => blob instanceof File ? blob : new File([blob], "tldrawFile", { type: blob.type })
  );
  editor.markHistoryStoppingPoint("paste");
  await putPastedExternalContent(
    editor,
    {
      type: "files",
      files,
      point,
      sources
    },
    { source: clipboardPasteSource, point }
  );
}
export {
  pasteFiles
};
//# sourceMappingURL=pasteFiles.mjs.map
